import React, { useState } from 'react';
import { IonContent, IonPage, IonRouterLink } from '@ionic/react';
import AppHeader from '../components/AppHeader';
import AccountForm from '../components/AccountForm';
import AccountHeader from '../components/AccountHeader';
import LogoutBtn from '../components/LogoutBtn';
import DeleteAccountBtn from '../components/DeleteAccountBtn';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { Patient } from '../models';
import { connect } from 'react-redux';
import PatientSwitcher from '../components/PatientSwitcher';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user!,
    isLoggedIn: !!state.authentication.accessToken
  };
};

const Account: React.FC<ReturnType<typeof mapStateToProps>> = (props) => {
  const [lastUpdate, setLastUpdate] = useState(Date.now());

  const [currentEditionPatient, setCurrentEditionPatient] = useState<Patient>(
    props.user.patient
  );

  return (
    <IonPage>
      <AppHeader />
      <IonContent class="ion-padding">
        <>
          <div className="wrapper wrapper--large">
            <div className="ion-hide-md-up">
              <AccountHeader />
            </div>
            <h3>Éditer mes informations et celles de mes proches</h3>
            <PatientSwitcher
              lastUpdate={lastUpdate}
              allowDelete={true}
              defaultPatient={currentEditionPatient}
              onSelectPatient={(patient: Patient) =>
                setCurrentEditionPatient(patient)
              }
            />
          </div>

          <AccountForm
            patient={currentEditionPatient}
            onUpdated={() => {
              setLastUpdate(Date.now());
            }}
            key={currentEditionPatient.id}
          />
          <div className="ion-margin-top">
            <LogoutBtn />
            <DeleteAccountBtn />
          </div>
          <div className="ion-text-center ion-margin-top">
            <IonRouterLink
              routerLink="/dashboard/data-protection"
              className="ion-margin"
            >
              Data Protection
            </IonRouterLink>
            <IonRouterLink routerLink="/dashboard/cgu" className="ion-margin">
              CGU
            </IonRouterLink>
          </div>
        </>
      </IonContent>
    </IonPage>
  );
};

export default connect(mapStateToProps, null)(Account);
